import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  @Input() _load : Boolean;
  
  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    //this._load =  true;//this.sharedService._getLoader();
  }
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend/src/app/shared/loader/loader.component.ts